import { useContext } from "react";
import { useParams } from "react-router-dom";
import { EnvironmentsContext } from "../../contexts/environments/context";
import { PageWithRightPane } from "../../layouts/page_with_right_pane";
import { MyEnvironmentContainer } from "./container";
import { AddMyEnvironmentContainer } from "./add/container";

export const MyEnvironmentPage = () => {
  const params = useParams();
  const { deploymentId } = params;
  const { deployments } = useContext(EnvironmentsContext);
  const deployment = deployments.find(
    (deployment) => deployment.id === deploymentId
  );

  return (
    <PageWithRightPane>
      {deployment && deployment.version === "EnvFeatures" && (
        <MyEnvironmentContainer deploymentId={deploymentId!} />
      )}
      {!deployment && <AddMyEnvironmentContainer />}
    </PageWithRightPane>
  );
};
